import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrInvitationStatus.ts
var t = () => e("invitationStatus");
//#endregion
export { t as useTrInvitationStatus };
